import {
  PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_FIELD,
  PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_BUILDINGS_FIELD,
  PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_CATEGORIES_FIELD,
} from '../EditBuildingAndCategoryModal.constants'

export function getMappingRowFieldName(index, field) {
  return `${PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_FIELD}.${index}.${field}`
}

export function getMappingRowCategoriesName(index) {
  return getMappingRowFieldName(
    index,
    PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_CATEGORIES_FIELD
  )
}

export function getMappingRowBuildingsName(index) {
  return getMappingRowFieldName(
    index,
    PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_BUILDINGS_FIELD
  )
}
